import { render } from "./failed-shipment-table.vue?vue&type=template&id=87c47314&scoped=true"
import script from "./failed-shipment-table.vue?vue&type=script&lang=ts"
export * from "./failed-shipment-table.vue?vue&type=script&lang=ts"

import "./failed-shipment-table.vue?vue&type=style&index=0&id=87c47314&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-87c47314"

export default script